import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CompanySettings } from '../../model/company-settings/company-settings';
import { ApplicationSettings } from '../../model/company-settings/application-settings';
import { FeatureConfiguration } from '../../model/plan/feature-configuration';

@Component({
  selector: 'app-menu-bar-title',
  standalone: true,
  templateUrl: './menu-bar-title.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu-bar-title.component.scss',
})
export class MenuBarTitleComponent {
  @Input() companySettings?: CompanySettings | null;
  @Input() applicationSettings?: ApplicationSettings | null;
  @Input() featureConfiguration?: FeatureConfiguration | null;
}
